// vendor
import { defineComponent, ref } from "@vue/composition-api";
// project
import * as StudyAPI from "@/services/api/studies";
import * as SessionAPI from "@/services/api/sessions";
import { Study } from "@/psychlab/types";
import { formatDateString } from "@/utils/text";

type OutputData = {
	type:"export-study",
	study:string;
	args:{
	}
}

type DoneHandler = (s:OutputData) => void;

type Modal = {
	hide():void
}

export const ExportStudyModal = defineComponent({

	props:{
		studyId:{
			type:String,
			required:true
		}
	},
	setup(props){

		const modal = ref<Modal>();
		const sessionCount = ref(0);
		const show = ref(false);
		const study = ref<Study>();
		const onDone = ref<DoneHandler>();

		const formatDate = (v:string) => {
			return formatDateString(v);
		}
		
		const ok = () => {
			if(!modal.value){
				console.error("Unable to open modal: ExportStudy");
				return;
			}
			modal.value.hide();
			if(onDone.value){
				onDone.value({ type: "export-study", study:props.studyId, args: { } })
			}
		}

		const hide = () => {
			show.value = false;
			study.value = undefined;
			onDone.value = undefined;
			sessionCount.value = 0;
		}

		const open = async (fn:DoneHandler) => {
			try {
				const s = await StudyAPI.getStudy(props.studyId);
				const c = await SessionAPI.getSessionCount({ group: props.studyId });
				study.value = s;
				sessionCount.value = c
			}
			catch(err){
				console.error(err.message);
			}
			show.value = true;
			onDone.value = fn;
		}

		return {
			modal,
			study,
			sessionCount,
			show,
			formatDate,
			ok,
			hide,
			open
		};
	}
	
});